import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {AbstractInputDirective} from '../AbstractInputDirective';
import {StringUtil} from '../../StringUtil';

@Component({
  selector: 'digires-autocomplete-input',
  templateUrl: './autocomplete-input.component.html',
  styleUrls: ['./autocomplete-input.component.scss']
})
export class AutocompleteInputComponent extends AbstractInputDirective implements OnChanges {

  @ViewChild('input') inputElement: ElementRef<HTMLInputElement>;

  @Output() selected = new EventEmitter<any>();
  @Output() filtered = new EventEmitter<any[]>();
  @Input() items: any[];
  @Input() itemToId: ((value: any) => any) = value => value;
  @Input() itemToLabel: ((value: any) => string) = value => value;
  filteredItems: any[];

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes.items) {
      this.filteredItems = this.items;
    }
  }

  override getValue() {
    const rawValue = super.getValue();
    const item = this.items.find(item => this.itemToId(item) === rawValue);
    return !!item ? this.itemToId(item) : null;
  }

  onFilterItems(event: any): void {
    const value = event.target.value;
    if (!value) {
      this.onItemSelected(null);
      return;
    }
    this.filteredItems = this.items.filter(item => {
      return StringUtil.filteredIncludes(this.itemToLabel(item), value);
    });
    this.filtered.emit(this.filteredItems);

    const foundOpt = this.filteredItems.find(item => {
      return StringUtil.filteredEquals(this.itemToLabel(item), value);
    });
    if (foundOpt) {
      this.onItemSelected(this.itemToId(foundOpt));
    }
  }

  onItemSelected(value: any): void {
    this.filteredItems = this.items;
    this.patch(value);
    this.selected.emit(value);
  }

  requestFocusForInput() {
    try {
      this.inputElement.nativeElement.focus();
    } catch (e) {
      console.error(e);
    }
  }

}
